import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Navigation from './components/Navigation';
import UserMenu from './components/UserMenu';

import Home from './pages/Home';
import Admin from './pages/AdminPages/Admin';
import Portal from './pages/Portal';
import Customers from './pages/StaffPages/Customers';
import Profile from './pages/Profile';
import Products from './pages/AdminPages/Products';
import Categories from './pages/AdminPages/Categories';
import Login from './components/Login';
import TempLogin from './components/TempLogin';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

// Wrapper to handle version check + layout
function AppWrapper() {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  // Pages where the user icon should be hidden
  const hideUserMenu = ['/login', '/register', '/forgot-password', '/reset-password', '/tempLogin'].includes(location.pathname);

  useEffect(() => {
    fetch('/version.json')
      .then(res => res.json())
      .then(data => {
        const currentVersion = localStorage.getItem('app_version');
        if (currentVersion && currentVersion !== data.version) {
          const shouldReload = window.confirm(
            `You are currently using version: ${currentVersion} of this Application. A new version: ${data.version} is available.\n\nFeatures added: ${data.changes}\n\nDownload?`
          );
          if (shouldReload) {
            localStorage.setItem('app_version', data.version);
            window.location.reload();
          }
        } else {
          localStorage.setItem('app_version', data.version);
        }
      });
  }, []);

  return (
    <>
      <Navigation />
      {!hideUserMenu && isLoggedIn && <UserMenu />}
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/tempLogin" element={<TempLogin />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route path="/home" element={isLoggedIn ? <Home /> : <Navigate to="/login" />} />
        <Route path="/admin" element={isLoggedIn ? <Admin /> : <Navigate to="/login" />} />
        <Route path="/profile" element={isLoggedIn ? <Profile /> : <Navigate to="/login" />} />
        <Route path="/portal" element={isLoggedIn ? <Portal /> : <Navigate to="/login" />} />
        <Route path="/customers" element={isLoggedIn ? <Portal /> : <Navigate to="/login" />} />
        <Route path="/products" element={isLoggedIn ? <Products /> : <Navigate to="/login" />} />
        <Route path="/categories" element={isLoggedIn ? <Categories /> : <Navigate to="/login" />} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
